import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';

export const TitleCard = ({ text }) => <Title>{text}</Title>;

const Title = styled.h3`
  color: inherit;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.1;
  letter-spacing: 0px;

  @media ${Points.tablet_landscape} {
    font-size: 20px;
  }

  @media ${Points.laptop_wide} {
    font-size: 24px;
  }

`;
